export enum ShopperAgentChannelKind {
  Sms = "sms",
  Email = "email",
  Imessage = "imessage",
  Rcs = "rcs",
}
